import React from 'react'

import { Box } from '@mui/material'
import NumSearchesBlock from 'Pages/ReportsAlerts/Reports/@components/NumSearchesBlock'
import { dsColorNew } from '@palette'

export default function numSearchesColumn() {

	return {
		name: 'numSearches',
		label: 'Num Searches',
		options: {
			customBodyRowRenderLite: (value) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: value > 1000 ? dsColorNew.dangerRed : dsColorNew.successText}}>
					<NumSearchesBlock numSearches={value}/>
				</Box>
			)
		}
	}
}
